"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineBreak = exports.createHtmlFromLineBreak = void 0;
var react_1 = __importDefault(require("react"));
var createHtmlFromLineBreak = function () {
    return "<br/><span>&#8203;</span>";
};
exports.createHtmlFromLineBreak = createHtmlFromLineBreak;
var LineBreak = function () {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("br", null),
        react_1.default.createElement("span", null, "\u200B")));
};
exports.LineBreak = LineBreak;
